var _style, _circle, _circle2, _circle3, _circle4, _circle5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoadingSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    "data-qa-selector": "loading_spinner",
    style: {
      WebkitAnimation: "rotate 2s linear infinite",
      animation: "rotate 2s linear infinite",
      height: "auto",
      WebkitTransformOrigin: "center center",
      msTransformOrigin: "center center",
      transformOrigin: "center center"
    }
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@-webkit-keyframes rotate{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes rotate{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes grow{0%,to{stroke-dasharray:0,138.23}50%{stroke-dasharray:27.646,138.23}}@-webkit-keyframes grow{0%,to{stroke-dasharray:0,138.23}50%{stroke-dasharray:27.646,138.23}}.Loading-Spinner_svg__loader-path{stroke-dasharray:27.646,138.23;animation:grow 1.5s ease-in-out infinite;stroke-linecap:round}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Loading-Spinner_svg__loader-path Loading-Spinner_svg__one",
    cx: 25,
    cy: 25,
    r: 22,
    fill: "none",
    stroke: "#031E3E",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "Loading-Spinner_svg__loader-path",
    cx: 25,
    cy: 25,
    r: 22,
    fill: "none",
    stroke: "#FE971E",
    strokeWidth: 3,
    strokeDashoffset: -27.646
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "Loading-Spinner_svg__loader-path",
    cx: 25,
    cy: 25,
    r: 22,
    fill: "none",
    stroke: "#D54235",
    strokeWidth: 3,
    strokeDashoffset: -55.292
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "Loading-Spinner_svg__loader-path",
    cx: 25,
    cy: 25,
    r: 22,
    fill: "none",
    stroke: "#52A821",
    strokeWidth: 3,
    strokeDashoffset: -82.938
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "Loading-Spinner_svg__loader-path",
    cx: 25,
    cy: 25,
    r: 22,
    fill: "none",
    stroke: "#069bf3",
    strokeWidth: 3,
    strokeDashoffset: -110.584
  })));
}

export default "data:image/svg+xml,%3Csvg class='circular-loader' viewBox='0 0 50 50' data-qa-selector='loading_spinner'%3E %3Ctitle%3ELoading Spinner%3C/title%3E %3C!--- There is some fun math going on in here. - The viewbox has a width/height of 50. - the circle wants to take up this full width which means the radius = 25. - but we have a stroke width of 3 so subtract 6 from the diameter (50 - 6)/2 r=22 - circumference = 2* pi * r so our circumfrence is 138.23 - we have 5 circles minimic a section of one circle. 138.23/5 = 27.646 - stroke-dasharray = (length of stroke) length of gap. - stroke-dasharray: 27.646 138.23 Who ever said you wouldn't use geometry in the real world? --%3E %3Cstyle%3E .circular-loader %7B -webkit-animation: rotate 2s linear infinite; animation: rotate 2s linear infinite; height: auto; -webkit-transform-origin: center center; -ms-transform-origin: center center; transform-origin: center center; %7D .two %7B stroke-dashoffset: -27.646; %7D .three %7B stroke-dashoffset: -55.292; %7D .four %7B stroke-dashoffset: -82.938; %7D .five %7B stroke-dashoffset: -110.584; %7D .loader-path %7B stroke-dasharray: 27.646, 138.23; animation: grow 1.5s ease-in-out infinite; stroke-linecap: round; %7D @-webkit-keyframes rotate %7B 100%25 %7B -webkit-transform: rotate(360deg); transform: rotate(360deg); %7D %7D @keyframes rotate %7B 100%25 %7B -webkit-transform: rotate(360deg); transform: rotate(360deg); %7D %7D @keyframes grow %7B 0%25 %7B stroke-dasharray: 0, 138.23; %7D 50%25 %7B stroke-dasharray: 27.646, 138.23; %7D 100%25 %7B stroke-dasharray: 0, 138.23; %7D %7D @-webkit-keyframes grow %7B 0%25 %7B stroke-dasharray: 0, 138.23; %7D 50%25 %7B stroke-dasharray: 27.646, 138.23; %7D 100%25 %7B stroke-dasharray: 0, 138.23; %7D %7D %3C/style%3E %3Ccircle class='loader-path one' cx='25' cy='25' r='22' fill='none' stroke='%23031E3E' stroke-width='3' /%3E %3Ccircle class='loader-path two' cx='25' cy='25' r='22' fill='none' stroke='%23FE971E' stroke-width='3' /%3E %3Ccircle class='loader-path three' cx='25' cy='25' r='22' fill='none' stroke='%23D54235' stroke-width='3' /%3E %3Ccircle class='loader-path four' cx='25' cy='25' r='22' fill='none' stroke='%2352A821' stroke-width='3' /%3E %3Ccircle class='loader-path five' cx='25' cy='25' r='22' fill='none' stroke='%23069bf3' stroke-width='3' /%3E %3C/svg%3E";
export { SvgLoadingSpinner as ReactComponent };